import React from 'react';

// BL-177 Step 2d (section 1): the one checkbox, 18x18, raised, teal when checked, with a check mark.
// Used for channels (Email / SMS / Push / In-app / Voice). A real <input type="checkbox"> inside a <label>,
// so the whole label is clickable and a screen reader hears the name. `children` is the visible label;
// pass `aria-label` when there is none (table cells under a column heading).
export default function Checkbox({
    checked,
    onChange,
    children,
    'aria-label': ariaLabel,
    id,
    disabled = false,
    describedBy,
    className = '',
}) {
    return (
        <label className={`ia-checkbox ${disabled ? 'ia-checkbox--disabled' : ''} ${className}`}>
            <input
                type="checkbox"
                id={id}
                checked={checked === true}
                disabled={disabled}
                aria-label={ariaLabel}
                aria-describedby={describedBy || undefined}
                onChange={(event) => { if (!disabled && onChange) onChange(event.target.checked); }}
            />
            <span aria-hidden="true" className="ia-checkbox__box">
                <svg viewBox="0 0 12 12" width="12" height="12" focusable="false"><path d="M2.2 6.4 4.8 9 9.8 3.2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
            {children ? <span className="ia-checkbox__label">{children}</span> : null}
        </label>
    );
}
